import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { watchKeyboardScrollIntent } from './shared/lib/scroll-scenes';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * The static shell in index.html carries first paint. It has to stay until it
 * has actually been presented - pulling it on the first frame means the browser
 * never paints it, and largest-contentful-paint falls through to React's copy
 * of the same image several seconds later.
 */
function removeHeroShell(): void {
  const shell = document.getElementById('hero-shell');
  const shellImage = shell?.querySelector('img');

  if (!shell || !shellImage) {
    return;
  }

  const drop = () => {
    const waitForHero = () => {
      if (document.getElementById('hero')) {
        // Two frames after the hero exists: one to lay it out, one to present it.
        requestAnimationFrame(() => requestAnimationFrame(() => shell.remove()));
        return;
      }

      requestAnimationFrame(waitForHero);
    };

    requestAnimationFrame(() => requestAnimationFrame(waitForHero));
  };

  if (shellImage.complete) {
    drop();
    return;
  }

  shellImage.addEventListener('load', drop, { once: true });
  shellImage.addEventListener('error', drop, { once: true });
}

removeHeroShell();
watchKeyboardScrollIntent();
